<template>
	<div class="noodle-container">
		<div class="noodles">
			<div class="cap right"></div>
			<div class="cap back"></div>
			<div class="side right"></div>
			<div class="side back"></div>
			<div class="noodle noodles-1"></div>
			<div class="noodle noodles-2"></div>
			<div class="noodle noodles-3"></div>
			<div class="side left"></div>
			<div class="side front">
				<div class="eyes"></div>
				<div class="mouth"></div>
			</div>
			<div class="cap left"></div>
			<div class="cap front"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AppLoadingNoodles',
	};
</script>

<style scoped></style>
